export const TRANSLATIONS_JP_GENERATION = {
  "generate.title": "ドキュメント生成",
  "generate.subtitle": "選択したソースからエグゼクティブサマリーを作成",
  "generate.action": "生成",
  "generate.generating": "生成中...",
  "generate.sources.title": "ソース",
  "generate.sources.clear": "選択をクリア",
  "generate.sources.loading": "ドキュメントを読み込み中...",
  "generate.language": "言語",
  "generate.expertRole": "専門家",
  "generate.expertRole.general": "一般",
  "generate.message.label": "要約へのメッセージ（任意）",
  "generate.message.placeholder": "例：リスクと次のステップに焦点を当ててください…",
  "generate.message.counter": "{count}/{max}",
  "generate.validation.selectSource": "少なくとも1つのソースを選択してください。",
  "generate.toast.success": "下書きを生成しました。",
  "generate.toast.enqueued": "生成をキューに追加しました。数分で完了し、完了したら通知します。",
  "generate.errors.documents": "ドキュメントを読み込めませんでした。",
  "generate.errors.forbidden": "このプランでは生成できないか、上限に達しています。",
  "generate.errors.insufficientEvidence": "選択した証拠が不足しています。",
  "generate.errors.generic": "ドキュメントを生成できませんでした。",
  "generate.errors.download": "PDFをダウンロードできませんでした。",
  "generate.picker.title": "要約を生成するために、どのドキュメントを選択しますか？",
  "generate.picker.searchPlaceholder": "ドキュメントを検索…",
  "generate.picker.empty": "ドキュメントが見つかりません。",
  "generate.picker.selected": "件選択中",
  "generate.picker.confirm": "完了",
  "generate.picker.open": "ドキュメントを選択",
  "generate.sources.empty": "まだドキュメントが選択されていません。「ドキュメントを選択」から選んでください。",
  "generate.warnings.sourcesUnavailable": "一部のソースは利用できなくなったため削除されました。必要な場合は再度検索してください。",
  "generate.preview.title": "プレビュー",
  "generate.preview.empty": "ソースを選択して下書きを生成します。",
  "generate.download": "PDFをダウンロード",
  "generate.downloading": "ダウンロード中...",
  "generate.mySummaries": "生成ドキュメント",
  "generate.history.title": "生成ドキュメント",
  "generate.history.subtitle": "生成したエグゼクティブサマリーの履歴",
  "generate.export.docx": "DOCXをダウンロード",
  "generate.export.draftWatermark": "ダウンロードには「下書き」の透かしが入ります(未承認ドキュメント)",
  "generate.history.notify.ready": "エグゼクティブサマリーが完成しました。",
  "generate.history.notify.failed": "要約を生成できませんでした。",
  "generate.history.pagination.label": "ページ送り",
  "generate.history.pagination.prev": "前へ",
  "generate.history.pagination.next": "次へ",
  "generate.history.unnamedDocument": "ドキュメント",
  "generate.history.enqueuedBanner": "要約はバックグラウンドで生成中です。完了したら通知します。そのまま作業を続けられます。",
  "generate.history.dismiss": "閉じる",
  "generate.history.new": "新しいサマリー",
  "generate.history.col.files": "ファイル",
  "generate.history.col.created": "作成日",
  "generate.history.col.status": "ステータス",
  "generate.history.col.expert": "専門家",
  "generate.history.expert.general": "一般",
  "generate.history.col.actions": "操作",
  "generate.history.status.downloaded": "ダウンロード済み",
  "generate.history.status.pending": "未ダウンロード",
  "generate.history.status.processing": "処理中",
  "generate.history.status.completed": "完了",
  "generate.history.status.failed": "失敗",
  "generate.history.action.download": "PDFをダウンロード",
  "generate.history.action.regenerate": "再生成",
  "generate.history.empty": "まだサマリーを生成していません。",
  "generate.history.emptyCta": "最初のサマリーを生成",
  "generate.history.loading": "サマリーを読み込み中...",
  "generate.history.error": "サマリーを読み込めませんでした。",
  "generate.history.retry": "再試行",
  "generate.history.moreFiles": "+{count}",
  "generate.history.col.message": "メッセージ",
  "generate.history.noMessage": "—",
  "generate.lifecycle.tabs.label": "ステータスで絞り込む",
  "generate.lifecycle.tab.all": "すべて",
  "generate.lifecycle.tab.draft": "下書き",
  "generate.lifecycle.tab.in_review": "レビュー中",
  "generate.lifecycle.tab.approved": "承認済み",
  "generate.lifecycle.tab.rejected": "却下",
  "generate.lifecycle.tab.archived": "アーカイブ",
  "generate.lifecycle.status.draft": "下書き",
  "generate.lifecycle.status.in_review": "レビュー中",
  "generate.lifecycle.status.approved": "承認済み",
  "generate.lifecycle.status.rejected": "却下",
  "generate.lifecycle.status.archived": "アーカイブ済み",
  "generate.lifecycle.col.version": "バージョン",
  "generate.lifecycle.action.submit": "レビューに送る",
  "generate.lifecycle.action.approve": "承認する",
  "generate.lifecycle.action.reject": "却下する",
  "generate.lifecycle.action.archive": "アーカイブする",
  "generate.lifecycle.action.timeline": "変更履歴を見る",
  "generate.lifecycle.action.revise": "修正して再提出",
  "generate.lifecycle.action.unarchive": "復元",
  "generate.lifecycle.confirm.title": "操作の確認",
  "generate.lifecycle.confirm.submit": "この要約をレビューに送りますか？",
  "generate.lifecycle.confirm.approve": "この要約を承認しますか？レビュー済みコンテンツとして扱われます。",
  "generate.lifecycle.confirm.archive": "この要約をアーカイブしますか？以後は有効ではなくなります。",
  "generate.lifecycle.confirm.cancel": "キャンセル",
  "generate.lifecycle.confirm.accept": "確認",
  "generate.lifecycle.reject.title": "要約を却下",
  "generate.lifecycle.reject.reasonLabel": "却下理由（必須）",
  "generate.lifecycle.reject.placeholder": "この要約を却下する理由を入力してください...",
  "generate.lifecycle.reject.confirm": "却下する",
  "generate.lifecycle.confirm.revise": "この要約を下書きに戻して修正しますか？再度レビューに提出できます。",
  "generate.lifecycle.confirm.unarchive": "このアーカイブ済みの要約を復元しますか？下書きに戻ります。",
  "generate.lifecycle.toast.submitted": "要約をレビューに送りました。",
  "generate.lifecycle.toast.approved": "要約を承認しました。",
  "generate.lifecycle.toast.rejected": "要約を却下しました。",
  "generate.lifecycle.toast.archived": "要約をアーカイブしました。",
  "generate.lifecycle.toast.revised": "要約を下書きに戻しました。",
  "generate.lifecycle.toast.unarchived": "要約を下書きに復元しました。",
  "generate.lifecycle.toast.error": "操作を完了できませんでした。もう一度お試しください。",
  "generate.detail.view": "詳細を見る",
  "generate.detail.title": "要約の詳細",
  "generate.detail.close": "閉じる",
  "generate.detail.empty": "この要約には表示できる内容がありません。",
  "generate.lifecycle.timeline.title": "ステータス変更履歴",
  "generate.lifecycle.timeline.empty": "記録された遷移はありません。",
  "generate.lifecycle.timeline.error": "変更履歴を読み込めませんでした。",
  "generate.lifecycle.timeline.close": "閉じる",
  "generate.lifecycle.generatedByAi": "AI生成コンテンツ：正式な文書として使用する前に確認してください。",
  "generate.lifecycle.draftBadge": "下書き — 未承認",
};
